import React, { ReactElement, useEffect } from 'react'
import { getUserInfo } from 'redux/loginInfo/async-thunks'
import { useAppDispatch, useShallowEqualSelector } from 'redux/hooks'
import { userAccountInfo } from 'helpers/user'
import { updateDemographicInfoState } from 'redux/demographic/demographicSlice'
import {
  getDemographicChildInfo,
  getDemographicInfo
} from 'redux/demographic/async-thunks'
import { AccountInfoProps } from './typing'
import { AccountDetail, UserInfo } from './subcomponents'
import MaskNumber from '../MaskNumber/MaskNumber'

const AccountInfo = ({
  lastfourDigitAccountNumber,
  companyName
}: AccountInfoProps): ReactElement => {
  const dispatch = useAppDispatch()
  const {
    accessToken,
    accountNumber,
    accountIdProx,
    accountIndicator,
    firstName,
    lastName,
    hasUserInfoResponseSuccess
  } = useShallowEqualSelector(
    ({ authTokenInfo: { tokenInfo }, loginInfo, welcomePanel }) => ({
      accessToken: tokenInfo?.access_token,
      accountNumber: welcomePanel?.activeAccountInfo?.accountNumber,
      accountIdProx: welcomePanel?.activeAccountInfo?.accountID,
      accountIndicator: loginInfo.accountIndicator,
      firstName: loginInfo?.userInfo?.firstName,
      lastName: loginInfo?.userInfo?.lastName,
      hasUserInfoResponseSuccess:
        loginInfo?.userInfo?.hasUserInfoResponseSuccess
    })
  )

  const getUserDetail = () => {
    const { isProx, accountID } = userAccountInfo
    const accountId = isProx ? accountIdProx : accountID

    if (!hasUserInfoResponseSuccess) {
      dispatch(getUserInfo())
    }

    if (isProx) {
      if (accountIndicator?.toUpperCase() === 'P') {
        dispatch(
          getDemographicChildInfo({
            accountNumber,
            accessToken,
            accountID: accountId
          })
        )
      } else {
        dispatch(
          getDemographicInfo({
            accountNumber,
            accessToken,
            accountID: accountId
          })
        )
      }
    }

    return (): void => {
      dispatch(
        updateDemographicInfoState({
          isResponseFail: false,
          errorMessage: ''
        })
      )
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(getUserDetail, [])

  return (
    <>
      <UserInfo>
        Welcome, {firstName} {lastName}
      </UserInfo>
      <AccountDetail>
        {companyName}{' '}
        <MaskNumber lastFourDigits={lastfourDigitAccountNumber} charCount={7} />
      </AccountDetail>
    </>
  )
}

export default React.memo(AccountInfo)
